<template>
    <div class="l-ss-c-widget-image-search">
        <popup
            v-if="$configuration.features.imageSearch"
            :opened="store.state.ui.isImageSearchVisible"
            :title="$t('imageSearch.title')"
            class="l-ss-c-search-popup-image-search-popup"
            @close="() => toggleImageSearch(false)">
            <image-search-container
                @search="onImageSearch"
                @image-search-button-select-file-click="value => $emit('image-search-button-select-file-click', value)"
                @image-search-use-correct-link-click="value => $emit('image-search-use-correct-link-click', value)"
                @image-search-use-incorrect-link-click="value => $emit('image-search-use-incorrect-link-click', value)"
                @image-search-button-search-click="value => $emit('image-search-button-search-click', value)"/>
        </popup>
    </div>
</template>
<script>
    import ImageSearchContainer from '../core/components/image-search-container';
    import RootComponentMixin from '../core/mixins/root-component';
    import Popup from '../core/components/popup';

    export default {
        components: {
            ImageSearchContainer,
            Popup,
        },
        provide: RootComponentMixin.provide,
        props: {
            ...RootComponentMixin.props,
        },
        computed: {
            ...RootComponentMixin.computed,
        },
        watch: {
            'store.state.ui.isCompletionsVisible': {
                handler(value) {
                    if (value && !this.isFocused && this.value) {
                        this.$refs.input.focus();
                        this.isFocused = true;
                    }
                },
            },
            'store.state.ui.isImageSearchVisible': {
                handler(value) {
                    if (value) {
                        this.setPosition();
                    } else {
                        this.resetPosition();
                    }
                },
            },
        },
        methods: {
            ...RootComponentMixin.methods,
            onImageSearch(baseImage) {
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchVisible', value: false });
                this.store.commit('base64Image/SET_PROPERTY', baseImage);

                this.$emit('search-image');
            },
            toggleImageSearch(value) {
                this.store.commit('ui/SET_PROPERTY', {
                    key: 'isImageSearchVisible',
                    value: value === undefined ? !this.store.state.ui.isImageSearchVisible : !!value,
                });
                this.store.commit('ui/SET_PROPERTY', { key: 'isImageSearchLoader', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCategoriesListVisible', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isFiltersOpened', value: false });
                this.store.commit('ui/SET_PROPERTY', { key: 'isCompletionsVisible', value: false });
            },
            setPosition() {
                this.$wrapper = document.querySelector('.l-ss-c-host-wrapper-is-image-search');
                this.$wrapper.style.display = 'flex';
                this.bodyClient = document.body;
                this.bodyClient.style.overflow = 'hidden';
            },
            resetPosition() {
                this.$wrapper.style.display = 'none';
                this.bodyClient.style.overflow = 'auto';
            },
        },
    };
</script>
